(function () {
  'use strict';

  if (window.__pmcEnterpriseHeaderLoaded) return;
  window.__pmcEnterpriseHeaderLoaded = true;

  var roots = [];
  var scheduled = false;
  var cartObserver = null;
  var cartObserverTarget = null;

  function findRoots() {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-pmc-enterprise-header]'));
  }

  function setCompactState() {
    scheduled = false;
    var isCompact = window.scrollY > 24;

    roots.forEach(function (root) {
      var isStuck = root.dataset.stickyEnabled === 'true' && isCompact;
      root.classList.toggle('is-stuck', isStuck);
      root.classList.toggle(
        'is-compact',
        isStuck && root.dataset.compactOnScroll === 'true'
      );
    });
  }

  function requestCompactState() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(setCompactState);
  }

  function closeOtherMenus(active) {
    roots.forEach(function (root) {
      root.querySelectorAll('.pmc-enterprise-header__categories[open]').forEach(function (details) {
        if (details !== active) details.removeAttribute('open');
      });
    });
  }

  function readCounterValue(badge) {
    if (!badge) return 0;

    var source = badge.querySelector('.visually-hidden') ||
      badge.querySelector('[aria-hidden="true"]') ||
      badge;
    var match = String(source.textContent || '').replace(/,/g, '').match(/\d+/);
    var count = match ? parseInt(match[0], 10) : 0;

    return Number.isFinite(count) && count > 0 ? count : 0;
  }

  function normaliseCounterBadge(badge, count) {
    if (!badge || count < 1) return;

    var visibleCount = badge.querySelector('[aria-hidden="true"]');
    if (!visibleCount) {
      visibleCount = document.createElement('span');
      visibleCount.setAttribute('aria-hidden', 'true');
      badge.insertBefore(visibleCount, badge.firstChild);
    }

    var nextText = count > 99 ? '99+' : String(count);
    if (visibleCount.textContent !== nextText) visibleCount.textContent = nextText;
  }

  function syncCounterLinks(root) {
    root.querySelectorAll('[data-pmc-counter-link]').forEach(function (link) {
      var badge = link.querySelector('.cart-count-bubble, .count-bubble');
      var count = readCounterValue(badge);
      var label = link.dataset.pmcCounterLabel || '';

      normaliseCounterBadge(badge, count);
      if (label) {
        link.setAttribute('aria-label', label + ', ' + count + ' ' + (count === 1 ? 'item' : 'items'));
      }
    });
  }

  function connectCounterLinks(root) {
    syncCounterLinks(root);
    if (root.__pmcCounterObserver) return;

    root.__pmcCounterObserver = new MutationObserver(function () {
      syncCounterLinks(root);
    });
    root.__pmcCounterObserver.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function syncCartBubble(root) {
    var source = document.getElementById('cart-icon-bubble');
    var sourceCount = source ? source.querySelector('.cart-count-bubble') : null;
    var target = root.querySelector('[data-pmc-cart-count]');

    if (!target) return;

    var nextMarkup = sourceCount ? sourceCount.outerHTML : '';
    if (target.innerHTML !== nextMarkup) target.innerHTML = nextMarkup;
  }

  function connectCartBubble(root) {
    syncCartBubble(root);

    var source = document.getElementById('cart-icon-bubble');
    if (!source) return;

    var observerTarget = source.closest('.shopify-section') || source.parentElement;
    if (!observerTarget || observerTarget === cartObserverTarget) return;

    if (cartObserver) cartObserver.disconnect();
    cartObserverTarget = observerTarget;

    cartObserver = new MutationObserver(function () {
      roots.forEach(syncCartBubble);
    });

    cartObserver.observe(observerTarget, { childList: true, subtree: true, characterData: true });
  }

  function initRoot(root) {
    if (root.dataset.pmcReady === 'true') return;
    root.dataset.pmcReady = 'true';

    root.querySelectorAll('details').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open && details.classList.contains('pmc-enterprise-header__categories')) {
          closeOtherMenus(details);
        }
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      var opened = document.activeElement && document.activeElement.closest
        ? document.activeElement.closest('details[open]')
        : null;
      if (!opened || !root.contains(opened)) {
        var openMenus = root.querySelectorAll('details[open]');
        opened = openMenus.length ? openMenus[openMenus.length - 1] : null;
      }
      if (!opened) return;

      opened.removeAttribute('open');
      var summary = opened.querySelector('summary');
      if (summary) summary.focus();
    });
  }

  function init() {
    findRoots();
    roots.forEach(function (root) {
      initRoot(root);
      connectCartBubble(root);
      connectCounterLinks(root);
    });
    setCompactState();
  }

  document.addEventListener('click', function (event) {
    roots.forEach(function (root) {
      if (root.contains(event.target)) return;
      root.querySelectorAll('details[open]').forEach(function (details) {
        details.removeAttribute('open');
      });
    });
  });

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  document.addEventListener('shopify:block:select', function (event) {
    var details = event.target && event.target.closest ? event.target.closest('details') : null;
    if (details) details.setAttribute('open', '');
  });

  window.addEventListener('scroll', requestCompactState, { passive: true });
  window.addEventListener('resize', requestCompactState, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
